export default __webpack_public_path__ + "static/media/english_icon.d9a793bf.svg";